import { BillingAddress, LicenseType, LicenseValidityContext, PaymentMethodType, PricingInformation } from '@platform-frontend/marketplace';
import { SimpleRouterNavigationExtras } from '@platform-frontend/util';
import { RefreshCheckoutMessageParams } from '../flow';
import { GotoCheckoutFlowAction } from '../flow/flow.actions';
import { PaymentInformation } from '../payment-wallet';
import { PurchaseOrRenewAddition } from './model/purchase-or-renew-addition';

export class SelectLicenseType {
  static readonly type = '[ShoppingCart] Select license type';
  constructor(public licenseTypeId: string) {}
}

export class SelectLicenseValidity {
  static readonly type = '[ShoppingCart] Select license validity';
  constructor(public validity: LicenseValidityContext) {}
}

export class RequestRefreshPricing {
  static readonly type = '[ShoppingCart] Request refresh pricing';
}

export class RefreshPricing {
  static readonly type = '[ShoppingCart] Refresh pricing';
  constructor(public licenseTypeId: string | null, public countryCode: string | null, public billingAddressId: number | null, public quantity: number | null) {}
}

export interface PurchaseOrRenewActionParams {
  additions: PurchaseOrRenewAddition[];
  licenseType: LicenseType;
  paymentInformation: PaymentInformation;
  billingAddress: BillingAddress | null;
  country: string;
  pricingInformation: PricingInformation;
  quantity: number;
  validity: LicenseValidityContext | null;
}

export abstract class PurchaseOrRenew {
  constructor(public purchaseOrRenewActionParams: PurchaseOrRenewActionParams) {}
}

export class Purchase extends PurchaseOrRenew {
  static readonly type = '[ShoppingCart] Purchase';
}

export class Renew extends PurchaseOrRenew {
  constructor(public purchaseOrRenewActionParams: PurchaseOrRenewActionParams, public contractId: string) {
    super(purchaseOrRenewActionParams);
  }
  static readonly type = '[ShoppingCart] Renew';
}

export class GotoCommercialCheckout extends GotoCheckoutFlowAction {
  static readonly type = '[ShoppingCart] Goto commercial checkout';
  constructor(public startParams: RefreshCheckoutMessageParams, public extras?: SimpleRouterNavigationExtras) {
    super(startParams, extras);
  }
}

export class DownloadLatestInvoice {
  static readonly type = '[Invoices] Download latest invoice';
  constructor(public licenceTypeId: string, public paymentType: PaymentMethodType | null) {}
}
